import React from 'react';
import PropTypes from 'prop-types';
import { PlanLoaderProgressV6 } from '../PlanLoaderProgressV6';

const DELAY = 800;

function PlanLoaderSlideV7({ onContinue, heading, steps, reviews }) {
    const finishProgress = () => {
        setTimeout(() => {
            onContinue();
        }, DELAY);
    };

    return (
        <PlanLoaderProgressV6
            finish={finishProgress}
            heading={heading}
            steps={steps}
            reviews={reviews}
        />
    );
}

PlanLoaderSlideV7.propTypes = {
    onContinue: PropTypes.func.isRequired,
    heading: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
    reviews: PropTypes.array
};

export {
    PlanLoaderSlideV7
};
